module.exports = __webpack_public_path__ + "img/error.cd57676e.png";